<template>
    <rkm-modal
        ref="Modal"
        title="Opções de impressão"
    >
        <rkm-form-checkbox v-model="selectAll">
            Todos
        </rkm-form-checkbox>

        <rkm-form-checkbox-group
            :options="options"
            v-model="selectedOptions"
            stacked
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                :disabled="selectedOptions.length == 0"
                @click="print"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { file } from '@/mixins'

export default {
    data: () => ({
        selectAll: false,
        options: [
            { value: 'atendimento', text: 'Atendimento' },
            { value: 'receitaMedica', text: 'Receita médica' },
        ],
        selectedOptions: [],
        impressoes: {}
    }),
    mixins: [file],
    methods: {
        open(impressoes) {

            this.selectAll = false
            this.selectedOptions = []

            this.impressoes = impressoes

            this.$refs.Modal.show()
        },
        print() {

            this.selectedOptions.forEach(option => {

                if (option == 'atendimento') {

                    this.openPdfBase64(this.impressoes.atendimento)
                }
                else if (option == 'receitaMedica') {

                    this.impressoes.receitasMedicasAssinadas.forEach(rm => this.openPdfBase64(rm))
                }
            })
        },
    },
    watch: {
        'selectAll': function (selectAll) {

            this.selectedOptions = selectAll ? this.options.map(o => o.value) : []
        },
    }
}
</script>